module.exports = __webpack_public_path__ + "static/media/PrimaryContact.9f4427a8.svg";